import React, { useRef, useState, useEffect, useContext } from "react";
import ShowFormHeaders from "./ShowFormHeaders";
import ShowFormColumns from "./ShowFormColumns";
import {subscribe, unsubscribe} from '../events/events';
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../store/rootStore";


const Wall:React.FC = observer(() => {

  const rootStore = useContext(RootStoreContext);
  const {allChosenSubjects} = rootStore.subjectStore;
  const {subjectType} = rootStore.wallSettingsStore;

  const columnWidth = 225;
  const columnWidthMobile = 160;
  const formColumnWidth = 110;
  const formColumnWidthMobile = 30;
  const gutterWidth = 10;

  const mediaQueryTablet = window.matchMedia('(min-width: 768px)');

  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState<number>(-1);
  const [startY, setStartY] = useState<number>(-1);

  const [scrollLeft, setScrollLeft] = useState<number>(-1);
  const [scrollTop, setScrollTop] = useState<number>(-1);

  const [wallWidth, setWallWidth] = useState({width: '100%'});

  const [columnPlusGutterWidth, setcolumnPlusGutterWidth] = useState(0);

  const scrollRef = useRef(null);

  const mouseDown = (e) => {
    setIsDragging(true);
    
    setStartX(e.pageX - scrollRef.current!.offsetLeft);
    setStartY(e.pageY - scrollRef.current!.offsetTop);

    setScrollLeft(scrollRef.current!.scrollLeft);
    setScrollTop(scrollRef.current!.scrollTop);
  }

  const mouseLeave = (e) => {
    setIsDragging(false);
  }

  const mouseUp = (e) => {
    setIsDragging(false);

    // Round to nearest point
    const leftPos = scrollRef.current!.scrollLeft;

    let adjustedLeftPos = 0;
    const leftPosMod = (leftPos % columnPlusGutterWidth);
    // See if round up or down
    if(leftPosMod < columnWidth / 2) {
      // Round down
      adjustedLeftPos = leftPos - leftPosMod;
    } else {
      adjustedLeftPos = leftPos - leftPosMod + columnPlusGutterWidth;
    }

    scrollTo(adjustedLeftPos);
  }

  const mouseMove = (e) => {
    if(scrollRef.current === null) return;
    if(!isDragging) return;
    e.preventDefault();

    const x = e.pageX - scrollRef.current.offsetLeft;
    const walkX = (x - startX) * 1;

    const y = e.pageY - scrollRef.current.offsetTop;
    const walkY = (y - startY) * 1;
    scrollRef.current.scrollTo(scrollLeft - walkX, scrollTop - walkY);
  }

  const scrollWallLeft = (width : number) => {
    let leftPos = scrollRef.current!.scrollLeft;
    if(leftPos < 50) return;
    leftPos = leftPos - width;
    scrollTo(leftPos);
  }

  const scrollWallRight = (width : number) => {
    let leftPos = scrollRef.current!.scrollLeft;
    leftPos = leftPos + width;
    scrollTo(leftPos);
  }
  
  const scrollTo = (leftPos : number) => {
    scrollRef.current!.scrollTo(
      {
        top: scrollRef.current!.scrollTop,
        left: leftPos,
        behavior: 'smooth'
      });
  }
  
  const browserWindowResized = (event) => {
    if (event.matches ) {
      setWindowLarge();
    } else {
      setWindowSmall();
    }
  }

  const setWindowLarge = () => {
    const colWidth = columnWidth + gutterWidth;
    const formsWidth = formColumnWidth + gutterWidth;
    setColumnsAndWallWidth(colWidth, formsWidth);
  }

  const setWindowSmall = () => {
    const colWidth = columnWidthMobile + gutterWidth;
    const formsWidth = formColumnWidthMobile + gutterWidth;
    setColumnsAndWallWidth(colWidth, formsWidth);
  }

  const setColumnsAndWallWidth = (colWidth, formsWidth) => {
    setcolumnPlusGutterWidth(colWidth);

    const width = allChosenSubjects.length * (colWidth) + (formsWidth) + 20;
    setWallWidth({width: `${width}px`});
  }


  useEffect(() => {
    // Get viewport width
    if(mediaQueryTablet.matches){
      setWindowLarge();
    } else {
      setWindowSmall();
    }

    subscribe("scrollWallLeft", () => {scrollWallLeft(columnPlusGutterWidth);});
    subscribe("scrollWallRight", () => {scrollWallRight(columnPlusGutterWidth);});
    mediaQueryTablet.addEventListener('change', event => browserWindowResized(event));

    return () => {
      unsubscribe("scrollWallLeft", () => {scrollWallLeft(columnPlusGutterWidth);});
      unsubscribe("scrollWallRight", () => {scrollWallRight(columnPlusGutterWidth);});
      mediaQueryTablet.removeEventListener('change', event => browserWindowResized(event));
    }

  }, [allChosenSubjects, columnPlusGutterWidth]);


  return (
    <>
      {subjectType === 'specialistModule' ?
        <p className='specialist-modules__header'>Specialist modules are only available to pupils in Form Six.</p>
        : null
      }
      <div className='the-wall-holder subjects-wall' ref={scrollRef}>
        <div className='the-wall' style={wallWidth}
          onMouseDown={mouseDown}
          onMouseLeave={mouseLeave}
          onMouseUp={mouseUp}
          onMouseMove={mouseMove}
        >
          {subjectType === 'subject' ?
            <ShowFormHeaders />
            : null
          }
          <ShowFormColumns live={true} />
        </div>
      </div>
    </>
  )
});

export default Wall;
